// @flow
export const SET_SEARCH_CONDITION = 'SET_SEARCH_CONDITION'

/**
 * Reducer section
 */
export type SearchConditionType = {
  page: number,
  perPage: number,
  searchSessionId: string,
  startedAt: string,
  endedAt: string,
  amenities: Array<string>,
  geocode: string,
  locationText: string,
  minCapacity: number,
  maxCapacity: number,
  orderBy: string,
  hasDirectReservationPlans: boolean,
  hasLastMinuteDiscountPlans: boolean,
  ownerRank: string,
  minPrice: ?number,
  maxPrice: ?number,
  keyword: string,
  state: string,
  eventType: string,
  priceType: string,
  sponsoredPromotionId: Array<string>,
  withRecommend: boolean,
}

const initialState: SearchConditionType = {
  page: 1,
  perPage: 10,
  searchSessionId: null,
  startedAt: '',
  endedAt: '',
  amenities: [],
  geocode: '',
  locationText: '',
  minCapacity: 0,
  maxCapacity: 0,
  orderBy: '',
  hasDirectReservationPlans: false,
  hasLastMinuteDiscountPlans: false,
  ownerRank: '',
  minPrice: null,
  maxPrice: null,
  keyword: '',
  state: '',
  eventType: null,
  priceType: 'hourly',
  sponsoredPromotionId: [],
  withRecommend: false,
}

// FlowType
type Action = {
  type: string,
  payload: Object,
}

export function reducer(
  state: SearchConditionType = initialState,
  action: Action,
) {
  switch (action.type) {
    case SET_SEARCH_CONDITION:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export function setSearchCondition(payload: SearchConditionType): Action {
  return {
    type: SET_SEARCH_CONDITION,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/search.js